<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Add banner") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('MESSAGES.Banner images')"
            @selectImage="selectImage"
            :acceptVideo="true"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- End:: Image Upload Input -->

          <!-- <BaseImageUploadInput @file-selected="handleFileSelected" @file-removed="handleFileRemoved" /> -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
          />

          <base-select-input
            col="6"
            :optionsList="relatedTypes"
            :placeholder="$t('MESSAGES.bannerRelatedType')"
            v-model="data.related_type"
            required
          />
          <base-select-input
            v-if="data.related_type"
            col="6"
            :optionsList="relatedItemOptions"
            :placeholder="relatedItemPlaceholder"
            v-model="data.related_id"
            required
          />
          <div class="input_wrapper switch_wrapper my-5 col-lg-6" v-if="!isFixedBannerForm">
            <v-switch
              color="green"
              :label="
                data.is_fixed
                  ? $t('MESSAGES.bannerIsFixed')
                  : $t('MESSAGES.bannerNotFixed')
              "
              v-model="data.is_fixed"
              hide-details
            />
          </div>

          <!-- End:: Name Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "CreateAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        image2: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        descAr: null,
        descEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        is_fixed: false,
        related_type: null,
        related_id: null,
      },
      festivalsList: [],
      offersList: [],
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    relatedTypes() {
      return [
        { id: "festival", name: this.$t("MESSAGES.festival") },
        { id: "offer", name: this.$t("MESSAGES.offer") },
      ];
    },
    relatedItemOptions() {
      if (!this.data.related_type?.id) return [];

      return this.data.related_type.id === "festival"
        ? this.festivalsList
        : this.offersList;
    },
    relatedItemPlaceholder() {
      if (!this.data.related_type?.id) return "";

      return this.data.related_type.id === "festival"
        ? this.$t("MESSAGES.selectFestival")
        : this.$t("MESSAGES.selectOffer");
    },
    isFixedBannerForm() {
      const fixed = this.$route.query.fixed;
      return fixed === "1" || fixed === "true";
    },
  },

  watch: {
    "data.related_type"(newValue, oldValue) {
      if (newValue?.id !== oldValue?.id) {
        this.data.related_id = null;
      }
    },
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage2(selectedImage) {
      this.data.image2 = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    mapRelatedOptions(items) {
      return (items || []).map((item) => ({
        ...item,
        name: item.name || item.name_ar || item.name_en,
      }));
    },

    async getFestivalsList() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "festivals?page=0&limit=0&is_active=1",
        });
        this.festivalsList = this.mapRelatedOptions(res.data.data.data);
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    async getOffersList() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "offers?page=0&limit=0&is_active=1",
        });
        this.offersList = this.mapRelatedOptions(res.data.data.data);
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.related_type?.id) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.bannerRelatedType"));
        return;
      } else if (!this.data.related_id?.id) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.bannerRelatedItem"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("title[ar]", this.data.nameAr);

      REQUEST_DATA.append("title[en]", this.data.nameEn);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file); // Append the file to the FormData
      }

      if (this.data.publish_start_date) {
        REQUEST_DATA.append("start_date", this.data.publish_start_date);
      }
      if (this.data.publish_end_date) {
        REQUEST_DATA.append("end_date", this.data.publish_end_date);
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      REQUEST_DATA.append("is_fixed", this.data.is_fixed ? 1 : 0);
      REQUEST_DATA.append("related_type", this.data.related_type.id);
      REQUEST_DATA.append("related_id", this.data.related_id.id);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `banners`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/ads/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    if (this.isFixedBannerForm) {
      this.data.is_fixed = true;
    }

    this.getFestivalsList();
    this.getOffersList();
  },
};
</script>
